import React from 'react'
import { Link } from 'react-router-dom'

const TShirtPagination = () => {
    return (
        <div className='tShirtPagination'>
            <div className="container">
                <div className="row justify-content-center">

                    <div className='d-flex flex-column'>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    </div>

                    <div className='d-flex flex-column'>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    </div>

                    <div className='d-flex flex-column'>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/catalog/search' className="cards">

                            <div className="cardsHeader">
                                <img src="/assets/image/1.png" alt="" className="w-100" />
                                <div className="icon icon-heart"></div>
                            </div>
                            <div className="cardsBody">
                                <div className="top d-flex justify-content-around">
                                    <button className="btn first">Футболка “Marell” </button>
                                    <button className="btn"><img src="/assets/icon/cardBag.svg" alt="" /></button>
                                </div>
                                <div className="bottom d-flex justify-content-around">
                                    <div className=''>
                                        <h5>RUB</h5>
                                        <h4>1600 P</h4>
                                    </div>
                                    <div className=''>
                                        <h5>AMARELL</h5>
                                        <h4>94</h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star mr-1"></i>
                                        <i className="icon icon-star"></i>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    </div>


                </div>
            </div>
        </div>
    )
}

export default TShirtPagination